import script from "./ListsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ListsPage.vue?vue&type=style&index=0&id=0fb43d14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb43d14"]])

export default __exports__